import React from 'react';
import { MemoryRouter, Routes, Route } from 'react-router-dom';
import { ConfigContext } from './contexts';

import { ComponentSettings } from './types';
import { GlobalStateProvider } from './providers/GlobalStateProvider';
import BillingHistoryContainer from './containers/BillingHistoryContainer';
import { InvoiceDetails } from './pages';

const App = ({ billingHistory }: ComponentSettings) => {
  return (
    <ConfigContext.Provider
      value={{
        billingHistory,
      }}
    >
      <GlobalStateProvider>
        <MemoryRouter>
          <Routes>
            <Route path="/" element={<BillingHistoryContainer />} />
            <Route path="invoices/:invoiceId" element={<InvoiceDetails />} />
          </Routes>
        </MemoryRouter>
      </GlobalStateProvider>
    </ConfigContext.Provider>
  );
};

export default App;
